export default {
    MAIN_PAGE: '/',
    OBCHODNI_PODMINKY: '/nezarazeny-ucet/obchodni-podminky',
    OBCHODNI_PODMINKY_NU: '/nezarazeny-ucet-zjisteni/obchodni-podminky',
    LOGIN: '/login',
    LOGOUT: '/odhlaseni',
    LOGIN_TOKEN: '/login/:tokenURL?',
    CHYBA: '/nezarazeny-ucet/chyba/:chyba?',
    VYPIS_BANKID_LOGIN: '/nezarazeny-ucet/bankid/:idzadosti?',
    VYPIS_BANKID_NOID: '/nezarazeny-ucet/bankid/',
    VYPIS_ZADOST: '/nezarazeny-ucet/zadost/:token?',
    VYPIS_PLATBA: '/nezarazeny-ucet/platba',
    VYPIS_NU_BANKID_LOGIN: '/nezarazeny-ucet-zjisteni/bankid/:idzadosti?',
    VYPIS_NU_BANKID_NOID: '/nezarazeny-ucet-zjisteni/bankid/',
    VYPIS_NU_ZADOST: '/nezarazeny-ucet-zjisteni/zadost/:token?',
    VYPIS_NU_PLATBA: '/nezarazeny-ucet-zjisteni/platba',
    CHYBA_NU: '/nezarazeny-ucet-zjisteni/chyba/:chyba?/:datum?',
    LEI_PREHLED_UCTU: '/lei-prehled-uctu',
    LEI_POPIS_SLUZBY: '/lei-popis-sluzby',
    ZAPIS_ZADOST_NOVA: '/nezarazeny-ucet-zapis/zadost/',
    ZAPIS_ZADOST_PLATBA: '/nezarazeny-ucet-zapis/platba/:idzadost?',
    ZAPIS_ZADOST: '/nezarazeny-ucet-zapis/token/:token?',
    CHYBA_NZ: '/nezarazeny-ucet-zapis/chyba/:chyba?/:datum?',
    ZAPIS_ZADOST_BANKID_LOGIN: '/nezarazeny-ucet-zapis/idzadost/:idzadost?'
};
